"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var lodash_1 = __importDefault(require("lodash"));
var useDetectOutsideClick_1 = require("../../hooks/useDetectOutsideClick");
var FIlterItem_1 = __importDefault(require("../../components/FIlterItem/FIlterItem"));
var filters_1 = require("../../helpers/filters");
var FilterActions_1 = __importDefault(require("./FilterActions"));
var schemaHelper_1 = require("../../helpers/schemaHelper");
var auth_1 = require("../../helpers/auth");
var loginSlice_1 = require("../login/loginSlice");
var DropDown_1 = __importDefault(require("./DropDown"));
var PriorityNav_1 = require("../../components/PriorityNav");
var Localization_1 = require("../../constants/Localization");
var useToggleDomElementStyle_1 = __importDefault(require("../../hooks/useToggleDomElementStyle"));
var Filter = function (_a) {
    var filters = _a.filters, changeFilter = _a.changeFilter, onSaveSearch = _a.onSaveSearch, appliedFilters = _a.appliedFilters, onStateChange = _a.onStateChange, onDistrictChange = _a.onDistrictChange, handlePublicCode = _a.handlePublicCode, handleBuildingNameChange = _a.handleBuildingNameChange, resetFilters = _a.resetFilters, children = _a.children, locationPathName = _a.locationPathName;
    var dispatch = react_redux_1.useDispatch();
    var moreDropdownRef = react_1.useRef(null);
    var appliedFiltersCount = filters_1.getAppliedFiltersCount(appliedFilters);
    var _b = useDetectOutsideClick_1.useDetectOutsideClick(moreDropdownRef, false), moreIsActive = _b[0], setMoreIsActive = _b[1];
    react_1.useLayoutEffect(function () {
        if (moreIsActive) {
            document.body.classList.add('mobile-scroll-disabled');
        }
        else {
            document.body.classList.remove('mobile-scroll-disabled');
        }
        return function () {
            document.body.classList.remove('mobile-scroll-disabled');
        };
    }, [moreIsActive]);
    useToggleDomElementStyle_1.default(moreIsActive);
    var toggleMoreFilters = function () {
        setMoreIsActive(!moreIsActive);
    };
    var handleSaveSearch = function () {
        auth_1.isAuthenticated()
            ? appliedFiltersCount && onSaveSearch()
            : dispatch(loginSlice_1.openLoginFormModal({ redirectAfterLogin: false }));
    };
    var getVisibleFilters = function (filters) {
        var visibleFilters = lodash_1.default.filter(filters, function (f) {
            if (f.displayCondition) {
                return schemaHelper_1.checkCondition(f.displayCondition, __assign({ deal: Localization_1.PagePrefix[locationPathName] }, appliedFilters));
            }
            return true;
        });
        // Filter options can have display condition as well
        return lodash_1.default.map(visibleFilters, function (f) {
            if (!lodash_1.default.isArray(f.options)) {
                return f;
            }
            return __assign(__assign({}, f), { options: f.options.filter(function (o) {
                    return schemaHelper_1.checkCondition(o.displayCondition, __assign({ deal: Localization_1.PagePrefix[locationPathName] }, appliedFilters));
                }) });
        });
    };
    var visibleFilters = getVisibleFilters(filters);
    return (react_1.default.createElement("div", { className: "search-box" },
        react_1.default.createElement("div", { className: "search-page-top" },
            react_1.default.createElement(react_1.default.Fragment, null,
                !lodash_1.default.isEmpty(filters) && (react_1.default.createElement(PriorityNav_1.PriorityNav, { moreBtn: moreDropdownRef, offset: 100, debounce: 0, itemPadding: 0, itemWidth: 160, className: "main-filters", visibleFilters: visibleFilters, appliedFilters: appliedFilters, dropdown: function (_a) {
                        var dropdownItems = _a.dropdownItems;
                        return (react_1.default.createElement(DropDown_1.default, { moreDropdownRef: moreDropdownRef, appliedFiltersCount: appliedFiltersCount, moreIsActive: moreIsActive, dropdownItems: dropdownItems, resetFilters: resetFilters, toggleMoreFilters: toggleMoreFilters }));
                    } }, lodash_1.default.map(visibleFilters, function (f, index) { return (react_1.default.createElement(FIlterItem_1.default, { changeFilter: changeFilter, filter: f, key: index, onStateChange: onStateChange, onDistrictChange: onDistrictChange, handleBuildingNameChange: handleBuildingNameChange, handlePublicCode: handlePublicCode, appliedFilters: appliedFilters })); }))),
                children)),
        react_1.default.createElement(FilterActions_1.default, { appliedFiltersCount: appliedFiltersCount, resetFilters: resetFilters, handleSaveSearch: handleSaveSearch })));
};
exports.default = react_1.memo(Filter);
